<ng-content select=".at-header-group"></ng-content>
<ol class="itinerary-list">
  @for (day of itinerary().days; track day.day) {
    <li class="itinerary-day body-copy-md">
      <div #daySection class="section-details open itinerary-day-content">
        <button class="section-summary heading-lg" (click)="daySection.classList.toggle('open')">
          {{ day.summary }}
        </button>
        <div class="grid-wrapper">
          <ol class="itinerary-activity-list">
            @for (activity of day.itinerary; track activity.activity) {
              <li class="itinerary-activity" [attr.data-time]="activity.timeOfDay">
                <div class="itinerary-activity-details">
                  <p class="body-copy-sm choal">
                    {{ activity.activity }}
                  </p>
                </div>
              </li>
            }
          </ol>
        </div>
      </div>
    </li>
  }
  @if (itinerary().operatorAvailable && canContactExpert()) {
    <li class="itinerary-action body-copy-md">
      <div #operatorSection class="section-details open itinerary-day-content">
        <button class="section-summary heading-lg" (click)="operatorSection.classList.toggle('open')">
          Get Expert Help
        </button>
        <div class="grid-wrapper">
          <p>
            Share your email to get expert help with your trip. Our vetted vendors will reach out to arrange booking
          </p>

          <label class="checkbox send-email-checkbox" ariaLabel="share email to the expert">
            <input
              type="checkbox"
              name="shareEmail"
              [formControl]="shareEmailControl"
              (change)="shareEmail.emit(shareEmailControl.value || false)" />
            <span>Share my email</span>
          </label>
        </div>
      </div>
    </li>
  }
</ol>
<ng-content select=".at-action"></ng-content>
